import { useSetAtom as p } from "jotai";
import { useResetAtom as t } from "jotai/utils";
import { cartItemsAtom as f } from "./index34.mjs";
import { clientDetailsAtom as A } from "./index55.mjs";
import { stepAtom as l, bookingSummaryShowAtom as S } from "./index25.mjs";
import { paymentAtom as u } from "./index57.mjs";
import { resetDatesAtom as R } from "./index26.mjs";
import { selectedRateAtom as d } from "./index60.mjs";
import { selectedRoomAtom as y } from "./index63.mjs";
const E = () => {
  const e = t(f), o = t(A), m = t(l), r = t(S), s = t(u), c = p(R), n = t(d), i = t(y);
  return () => {
    [
      e,
      o,
      m,
      r,
      s,
      c,
      n,
      i
    ].forEach((a) => a());
  };
};
export {
  E as useResetStore
};
